module.exports = __webpack_public_path__ + "static/media/Cosenza.678caf93.png";